import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import PDFToolbar from '../PDFToolbar';
import { ReactComponent as ArrowLeft } from '../../assets/images/arrow-left.svg';
import ImageModal from './ImageModal';

const PDFViewer = ({ src, onClose, title }) => {
  const [imageUrl, setImageUrl] = useState('');
  const [photos, setPhotos] = useState([]);
  const indexLinks = () => {
    [...document.getElementsByClassName('rpv-core__inner-page')].forEach(page => {
      setPhotos([...page.getElementsByTagName('a')].map(a => a.href));
    });
  };
  const click = e => {
    if (e?.target?.href?.includes('photo')) {
      e.preventDefault();
      // setImageUrl(e.target.href.replace('development', 'local-front'));
      setImageUrl(e.target.href);
    }
  };
  const goTo = val => {
    const newIndex = photos.findIndex(x => x === imageUrl) + val;
    if (newIndex === photos.length) return setImageUrl(photos[0]);
    if (newIndex < 0) return setImageUrl(photos.at(-1));
    return setImageUrl(photos[newIndex]);
  };
  const canClick = useMemo(() => {
    const newIndex = photos.findIndex(x => x === imageUrl);

    return {
      next: newIndex + 1 === photos.length,
      prev: newIndex - 1 < 0
    };
  }, [photos, imageUrl]);

  const sidebarTabs = defaultTabs => {
    return defaultTabs.filter(x => x.title === 'Thumbnail');
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: PDFToolbar,
    sidebarTabs
  });
  const DefaultHeader = () => (
    <button
      className="protean-btn ml-auto ml-4 d-flex align-items-center"
      type="button"
      onClick={() => setImageUrl('')}
    >
      <ArrowLeft className="d-inline-flex" />
      Back to report
    </button>
  );

  const close = () => {
    setImageUrl('');
    onClose();
  };

  useEffect(() => {
    indexLinks();
  }, [imageUrl]);

  return (
    <div className="pdf-protean-viewer">
      {/* eslint-disable-next-line */}
      <div className="w-100 h-100" onClick={click}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
          <Viewer fileUrl={src} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      </div>
      <ImageModal
        imageUrl={imageUrl}
        onClose={close}
        Btn={DefaultHeader}
        title={title}
        isMany={photos.length > 1}
        goTo={goTo}
        canClick={canClick}
      />
    </div>
  );
};

PDFViewer.propTypes = {
  src: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default PDFViewer;
